import moment from "moment-timezone";

const handleValidDate = (date, str) => {
  const localTime = moment.utc(date).local();
  return date ? str ? localTime.format(str) : localTime.format("D MMM YYYY") : "";
};

export default handleValidDate;
